module.exports = __webpack_public_path__ + "img/line.678e598f.svg";